import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Dermatologist icon
 *
 * @category Medical
 */
const Dermatologist = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M19.246 15.372c-2.92 1.32-1.92 12.58-6.51 10.05-2.31-2.14 2.23-8.27.32-9.89-.48-.83-11.93-.57-7.34.44 1.56.26 4.74-.02 5.89.28.27.07.52.2.64.45.36 1.62-.93 4.15-1.15 5.89-.69 2.42.77 4.9 3.24 4.39 3.89-1.06 3.01-7.99 5.17-10.39 1.85-1.07 4.88-.09 6.71-.82 1.49-.92-6-.88-6.85-.44l-.12.05z"
        />
        <path
          fill="currentColor"
          d="M13.946 24.162c.38.09.62-.38.67-.75.36-2.81 3.47-14.94 10.62-18.4 1.11-.79.9-1.15-.27-.8-7.9 2.98-10.9 15.84-11.4 18.88-.1.38-.05.97.33 1.06h.05zm-6.681-5.77a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m13.191 2.07a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-9.91-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m13.41-.57a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-15.691 3.78a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m15.191 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-13.911 2.53a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m11.911 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-15.411.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m18.901 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-18.901-4.48a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m19.931-.26a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
        />
      </svg>
    );
  }
);

Dermatologist.displayName = 'Dermatologist';

export { Dermatologist };
